export default __webpack_public_path__ + "static/media/logo-mycool.ee648965.svg";